const breadCrumb = "Diário Digital - Horário da Turma";

const routes = [
  {
    path: "/horario-turma",
    name: "horario-turma",
    meta: {
      allowedPermissions: ["unidade_didatica_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/HorarioTurma/HorarioTurmaHome.vue"),
  },
  {
    path: "/horario-turma/novo/:turmaId",
    name: "horario-turma-novo",
    meta: {
      allowedPermissions: ["unidade_didatica_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/HorarioTurma/HorarioTurmaCad.vue"),
  },
];

export default routes;
